<footer class="site-footer">
  <!-- ADSENSE: FOOTER -->
<div class="footer-ad">
  <ins class="adsbygoogle"
       style="display:block"
       data-ad-client="ca-pub-XXXX"
       data-ad-slot="4444444444"
       data-ad-format="auto"
       data-full-width-responsive="true">
  </ins>
</div>

  <div class="footer-inner">
    <p>© {{ year }} DailyCity.in</p>

    <nav>
      <a routerLink="/about">About</a>
      <a routerLink="/contact">Contact</a>
      <a routerLink="/privacy-policy">Privacy Policy</a>
      <a routerLink="/terms-and-conditions">Terms & Conditions</a>
    </nav>
  </div>
</footer>
